import React from 'react';
import { NewClientContextProvider } from 'Context/NewClientContext';
import ClientContainer from './ClientContainer';

const ClientAppContainerContent = () => {
  return (
    <NewClientContextProvider>
      <ClientContainer />
    </NewClientContextProvider>
  );
};

export default ClientAppContainerContent;
